import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import SearchField from "../../components/SearchField/SearchField";
import { tariffesArraySelector, userSelector } from "../../store/selectors";
import plusIcon from "../../assets/plus-icon.svg";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import "./AdminReactionPacksScreen.css";
import momentTz from "moment-timezone";
import Avatar from "../../components/Avatar/Avatar";
import SortableTable from "../../components/SortableTable/SortableTable";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AppLogo from "../../assets/AppLogoBlue.svg";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import {
  deleteTariff,
  fetchOrganizationsTariffes,
  fetchTariffes,
} from "../../store/tariffesSlice";
import AddTariffModal from "../../components/AddTariffModal/AddTariffModal";
import EditTariffModal from "../../components/EditTariffModal/EditTariffModal";
import TariffVersionsModal from "../../components/TariffVersionsModal/TariffVersionsModal";
import OrganizationChangeTariffModal from "../../components/OrganizationChangeTariffModal/OrganizationChangeTariffModal";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import { fetchReactionsPacks } from "../../store/usersSlice";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import AddReactionPackModal from "../../components/AddReactionPackModal/AddReactionPackModal";

const eternalTariffesIds = [8, 19, 21];

const AdminReactionPacksScreen = () => {
  const user = useSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userName = user?.email;
  const [availableTariffesArray, setAvailableTariffesArray] = useState([]);
  const [packsArray, setPacksArray] = useState([]);
  const [packToEdit, setPackToEdit] = useState(null);
  const [direction, setDirection] = useState("desc");
  const [orderBy, setOrderBy] = useState("id");
  const [isAddPackModalOpened, setIsAddPackModalOpened] = useState(false);

  const formatDate = (dateString) => {
    const res = momentTz(dateString).tz("etc/gmt-3").format("DD.MM.YYYY");
    return res;
  };

  function descendingComparator(a, b, property) {
    if (property === "startDate") {
      return momentTz(b.startDate, "DD.MM.YYYY")
        .utc()
        .diff(momentTz(a.startDate, "DD.MM.YYYY").utc());
    }
    if (b[property] < a[property]) {
      return -1;
    }
    if (b[property] > a[property]) {
      return 1;
    }
    return 0;
  }

  const getComparator = (directionValue, orderByValue) => {
    return directionValue === "desc"
      ? (a, b) => descendingComparator(a, b, orderByValue)
      : (a, b) => -descendingComparator(a, b, orderByValue);
  };

  const prepareData = (filteredOrganizations) => {
    const mappedData = filteredOrganizations.map((organization) => ({
      id: organization.organizationId,
      organizationName: organization.organizationName,
      tariff:
        (organization.subscription && organization.subscription.plan.name) ||
        "Отсутствует",
      orgData: organization,
      startDate:
        (organization.subscription &&
          formatDate(organization.subscription.startDate)) ||
        "-",
    }));

    const sortedData = mappedData.sort(getComparator(direction, orderBy));

    return sortedData;
  };

  useEffect(() => {
    updateInfo();
  }, []);

  const updateInfo = () => {
    dispatch(fetchReactionsPacks({})).then((res) => {
      if (!res.error) {
        const resultArray = res.payload.content;
        setPacksArray(resultArray);
        // const orgArray = res.payload.content.sort((a, b) =>
        //   a.organizationId > b.organizationId ? -1 : 1
        // );
        // setOrganizationsArray(orgArray);
      }
    });
    dispatch(fetchTariffes({ isDeleted: false })).then((res) => {
      setAvailableTariffesArray(res.payload);
    });
  };

  const onRequestSort = (event, property) => {
    const isAsc = orderBy === property && direction === "asc";
    setDirection(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <div className="adminScreen-App">
      {/* HEADER */}
      <div className={"adminScreen-header"}>
        <div className="header-left">
          <div
            onClick={() => navigate("/home", { replace: true })}
            className={"mainScreen-logoBlock"}
            style={{ cursor: "pointer" }}
          >
            <img src={AppLogo} style={{ height: "80%" }} alt="logo" />
          </div>
        </div>
        <div className="header-actions">
          <SearchField onValueChanged={(value) => setSearchQuery(value)} />
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      <div className="admin-container" style={{ alignItems: "flex-start" }}>
        <ProfileSidebar activeTab="admin" subActive="reaction-packs" />
        <main className="admin-main">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <h1 className="admin-title">Паки реакций</h1>
            <PrimaryButton
              text={"Создать"}
              onClick={() => setIsAddPackModalOpened(true)}
              style={{ marginLeft: "12px", padding: "8px 24px" }}
            ></PrimaryButton>
            {/* <button className="admin-add-tariff-btn" onClick={onPressAddTariff}>
              <img src={plusIcon} alt="plus" width={16} height={16} />
              Добавить тариф
            </button> */}
          </div>
          <TableContainer
            component={Paper}
            style={{
              backgroundColor: "transparent",
              color: "white",
              boxShadow: "none",
              overflowX: "hidden",
              overflowY: "scroll",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    key="id"
                    style={{ color: "white", fontWeight: "bold" }}
                    align="left"
                  >
                    id
                    <TableSortLabel
                      active={orderBy === "id"}
                      direction={orderBy === "id" ? direction : "asc"}
                      onClick={createSortHandler("id")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "white !important",
                          height: 15,
                          marginBottom: 0.3,
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell
                    key="name"
                    style={{ color: "white", fontWeight: "bold" }}
                  >
                    Название
                    <TableSortLabel
                      active={orderBy === "organizationName"}
                      direction={
                        orderBy === "organizationName" ? direction : "asc"
                      }
                      onClick={createSortHandler("organizationName")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "white !important",
                          height: 15,
                          marginBottom: 0.3,
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell
                    key="startDate"
                    style={{ color: "white", fontWeight: "bold" }}
                  >
                    Реакции
                    <TableSortLabel
                      active={orderBy === "startDate"}
                      direction={orderBy === "startDate" ? direction : "asc"}
                      onClick={createSortHandler("startDate")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "white !important",
                          height: 15,
                          marginBottom: 0.3,
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell
                    style={{ color: "white", fontWeight: "bold" }}
                    align="left"
                  >
                    Изменить
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {packsArray.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell style={{ color: "white" }} align="left">
                      {row.id}
                    </TableCell>
                    <TableCell
                      style={{ color: "white" }}
                      component="th"
                      scope="row"
                    >
                      {row.name}
                    </TableCell>
                    <TableCell style={{ color: "white" }} align="left">
                      {row.reactions.reduce((acc, curr) => {
                        return acc + curr.emoji;
                      }, "")}
                    </TableCell>
                    <TableCell style={{ color: "white" }} align="left">
                      <div
                        onClick={() => setOrgToEdit(row.orgData)}
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          padding: 10,
                          borderRadius: 8,
                          width: 100,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxSizing: "border-box",
                          cursor: "pointer",
                          alignSelf: "flex-end",
                        }}
                      >
                        Изменить
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </main>
        {isAddPackModalOpened && (
          <AddReactionPackModal
            onClose={() => setIsAddPackModalOpened(false)}
            onSubmit={() => {
              updateInfo();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AdminReactionPacksScreen;
